import { Injectable, signal } from '@angular/core';
import { MANUAL_TOKEN_KEY } from '@constants/auth.constants';

@Injectable({ providedIn: 'root' })
export class ManualTokenStateService {
  private readonly _isActive = signal(false);
  readonly isActive = this._isActive.asReadonly();

  activate(): void {
    if (localStorage.getItem(MANUAL_TOKEN_KEY)) {
      this._isActive.set(true);
    }
  }

  deactivate(): void {
    this._isActive.set(false);
  }
}
